import { forwardRef, LegacyRef, ReactNode } from 'react'
import React from 'react'

import cn from 'classnames'
 

export const ButtonPrimary = forwardRef(function (
  {
    label = 'Сохранить',
    icon,
    onClick,
    backgroundColor = 'primary',
    loading,
    disabled,
    iconPosition = 'left',
    className = '',
    ...rest
  } ,
  ref
) {
  return (
    <button
      {...rest}
      ref={ref}
      className={cn(
        className,
        'rounded-lg text-sm leading-4 py-2.5 px-4 border font-medium flex items-center',
        'hover:duration-500 focus:outline-none',
        'focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2',
        {
          ['text-blue-500 bg-blue-100 border-blue-100']: backgroundColor === 'primary',
          ['text-gray-900 bg-white border-blue-100']: backgroundColor === 'white',
          ['text-green-900 bg-green-100 border-green-200 hover:bg-green-200 focus:bg-green-200']:
            backgroundColor === 'green',
          ['text-red-700 bg-red-100 border-red-100']: backgroundColor === 'danger',
          ['hover:bg-blue-200 focus:bg-blue-200']: !disabled && backgroundColor === 'primary',
          ['hover:bg-gray-100 focus:bg-gray-100']: !disabled && backgroundColor === 'white',
          ['hover:bg-red-50 focus:bg-red-50']: !disabled && backgroundColor === 'danger',
          ['opacity-35 cursor-not-allowed !bg-gray-200 border-gray-200 hover:none']: disabled,
          ['cursor-wait']: loading,
          ['flex-row-reverse']: iconPosition === 'right'
        }
      )}
      disabled={disabled || loading}
      onClick={!loading && !disabled ? onClick : undefined}
    >
      {icon && (
        <span
          className={
            !label ? ''
            : iconPosition === 'right' ?
              'ml-2'
            : 'mr-2'
          }
        >
          {icon}
        </span>
      )}
      {label}
    </button>
  )
})

ButtonPrimary.displayName = 'ButtonPrimary'
